// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--p4O9j";
export var center = "blog-module--center--bVNLT";
export var links = "blog-module--links--Yt3bQ";
export var link = "blog-module--link--Mi9vc";
export var active = "blog-module--active--2Km2w";